import { useEffect } from "react";

/**
 * Mirrors an element's rendered height into a CSS variable on <html>, so sticky elements
 * elsewhere in the tree can offset by it. The value drops to 0px while the element is
 * display:none (e.g. hidden at this breakpoint) and is removed when it unmounts.
 */
export default function useElementHeightCssVar(ref, name, isMounted) {
  useEffect(() => {
    const root = document.documentElement;
    const element = ref.current;
    if (!isMounted || !element) return undefined;

    const update = () => root.style.setProperty(name, `${element.offsetHeight}px`);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(element);
    return () => {
      observer.disconnect();
      root.style.removeProperty(name);
    };
  }, [ref, name, isMounted]);
}
